/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import type {
  UserUnion
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary create visitor
 */
export const createVisitor = (

 signal?: AbortSignal
) => {


      return axiosClient<UserUnion>(
      {url: `/visitor`, method: 'POST', signal
    },
      );
    }




export const getCreateVisitorMutationKey = () => ['createVisitor'] as const;

export const getCreateVisitorMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVisitor>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVisitor>>, TError,void, TContext> => {

const mutationKey = getCreateVisitorMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVisitor>>, void> = () => {


          return  createVisitor()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVisitorMutationResult = NonNullable<Awaited<ReturnType<typeof createVisitor>>>

    export type CreateVisitorMutationError = ErrorType<unknown>


    /**
 * @summary create visitor
 */
export const useCreateVisitor = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVisitor>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createVisitor>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateVisitorMutationOptions(options), queryClient);
    }
